export const getSentryOption = () => ({
  isSentry: true,
  label: null,
  value: null,
});

export const injectSentry = (listOfOptions, sentry) => [...listOfOptions, sentry];
export const removeSentry = listOfOptions => listOfOptions.filter(item => !item.isSentry);
